import { render, staticRenderFns } from "./ParticipantNewForm.vue?vue&type=template&id=0dae82e0&scoped=true"
import script from "./ParticipantNewForm.vue?vue&type=script&lang=js"
export * from "./ParticipantNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae82e0",
  null
  
)

export default component.exports